module.exports = __webpack_public_path__ + "static/img/header_img.140d0bb8.png";